// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-wrapper {
	background-color: var(--background);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 40px;
	width: 100%;
	padding: 80px 0;
}

.catalog__content-wrapper {
	max-width: 1340px;
	padding: 0 20px;
	display: grid;
	grid-template-columns: 300px 1fr;
	width: 100%;
	gap: 24px;
}

.catalog__header {
	display: flex;
	max-width: 1340px;
	align-items: center;
	padding: 0 20px;
	justify-content: space-between;
	width: 100%;
}

.catalog__title {
	font-size: 48px;
	line-height: 48px;
	color: var(--dark);
}

.catalog__search-wrapper {
	position: relative;
	min-width: 300px;
}

.catalog__search-icon {
	position: absolute;
	right: 16px;
	top: 50%;
	transform: translateY(-50%);
	cursor: pointer;
}

.catalog__search-input {
	width: 100%;
	padding: 0 16px;
	border: 1px solid var(--border-transparent);
	border-radius: 4px;
	font-size: 16px;
	color: var(--secondary-text);
	height: 44px;
	padding-right: 40px;
}

.catalog__filters {
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
	border: 1px solid var(--border-transparent);
	border-radius: 8px;
	padding: 20px;
	height: fit-content;
	position: sticky;
	top: 20px;
}

.catalog__filter-block {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.catalog__filter-line {
	height: 1px;
	width: 100%;
	background-color: var(--border-transparent);
}

.catalog__clear-filters-button {
	background-color: var(--button);
	color: var(--background);
	padding: 8px 16px;
	border-radius: 4px;
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
	transition: 0.3s;
}

.catalog__clear-filters-button:hover {
	background-color: var(--button-hover);
	transition: 0.3s;
}

.catalog__filter-block-title {
	font-size: 20px;
	line-height: 23px;
	color: var(--dark);
}

.catalog__filter-list-items {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.catalog__products-list {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	width: 100%;
	gap: 24px;
}

.catalog__products-wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	gap: 24px;
	border-radius: 16px;
}

.catalog__product-block {
	background-color: var(--background);
	border-radius: 8px;
	overflow: hidden;
	transition: 0.3s;
	cursor: pointer;
	position: relative;
	border: 1px solid var(--border-transparent);
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.catalog__hover-wrapper {
	opacity: 0;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	transition: 0.3s;
	display: flex;
	justify-content: center;
	align-items: center;
}

.catalog__checkbox-wrapper {
	position: absolute;
	top: 10px;
	right: 10px;
}

.catalog__checkbox-wrapper input {
	width: 20px;
	height: 20px;
	color: white;
	background-color: white;
	margin-top: 0 !important;
}

.catalog__product-block:hover .catalog__hover-wrapper {
	opacity: 1;
	transition: 0.3s;
}

.catalog__product-details {
	padding: 20px;
	display: flex;
	flex-direction: column;
	gap: 8px;
	border-top: 1px solid var(--border-transparent);
}

.catalog__product-image {
	width: 100%;
	aspect-ratio: 1 / 1;
	border-radius: 8px;
}

.catalog__product-title {
	font-size: 16px;
	line-height: 20px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	font-weight: 500;
}

.catalog__view-button {
	background-color: var(--button);
	color: var(--background);
	padding: 8px 16px;
	border-radius: 4px;
	font-size: 16px;
	font-weight: 500;
	cursor: pointer;
	transition: 0.3s;
}

.catalog__view-button:hover {
	background-color: var(--button-hover);
	transition: 0.3s;
}

.catalog__filter-item {
	font-size: 15px;
	line-height: 16px;
	color: var(--dark);
	cursor: pointer;
	font-weight: 500;
	transition: 0.3s;
}

.catalog__filter-item:hover,
.catalog__filter-item.selected {
	color: var(--button);
	transition: 0.3s;
}

.catalog__empty-products {
	font-size: 24px;
	line-height: 28px;
	color: var(--dark);
	text-align: center;
	display: flex;
	width: 100%;
	justify-content: center;
	padding: 40px 0;
	border: 1px solid var(--border-transparent);
	border-radius: 8px;
}

@media (max-width: 950px) {
	.catalog__content-wrapper {
		grid-template-columns: 1fr;
	}

	.catalog__filters {
		display: none;
	}

	.catalog__header {
		flex-direction: column;
		gap: 20px;
		align-items: start;
	}

	.catalog__search-wrapper {
		position: relative;
		min-width: unset;
		width: 100%;
	}

	.catalog__title {
		font-size: 32px;
		line-height: 32px;
		color: var(--dark);
		text-transform: uppercase;
	}

	.catalog-wrapper {
		background-color: var(--background);
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 30px;
		width: 100%;
		padding: 40px 0;
	}
}

.public-menu-a {
	padding: 10px;
	display: flex;
	color: rgb(18, 63, 115);
	text-decoration: none;
	position: relative;
}

.active-public {
	border-color: rgb(18, 63, 115);
}

.active {
	text-decoration: none;
	color: #1a4074;
	transition: all 0.5s;
	position: relative;
}

.catalog-active::after {
	position: absolute;
	content: "";
	height: 2px;
	width: 100%;
	border-radius: none;
	bottom: -2px;
	left: 0;
	border-bottom: 2px solid #1c6fd1;
}

.dashboard-menu-ul {
	display: flex;
}

.dashboard-menu-li {
	display: flex;
	cursor: pointer;
	position: relative;
}

.catalog-button-blue {
	border: 1px solid rgba(28, 111, 209, 0.5);
	padding: 7px 15px;
	border-radius: 0;
	margin-right: 7px;
	background: rgb(18, 63, 115);
	color: #fff;
	transition: 0.4s;
	font-weight: 300;
	font-size: 15px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.catalog-button-blue:hover {
	background: rgb(18, 63, 115);
	color: #fff;
}

.max-height-38 {
	max-height: 38.5px;
	height: 100%;
}

.catalog-search-input {
	background-color: #f3faff;
	width: 90%;
}

.catalog-search-button {
	background-color: transparent;
	color: #c9c7d7;
}

.catalog-search-button:hover {
	color: rgb(18, 63, 115);
}

.search-box {
	border: 1px solid rgba(28, 111, 209, 0.5);
	color: #c9c7d7;
	height: 38.5px;
}

.search-box svg {
	cursor: pointer;
}

.categories-wrapper-container {
	border: 1px solid rgba(28, 111, 209, 0.5);
	padding: 5px;
}

.categories-button-show {
	border: none;
	background-color: transparent;
	min-width: 150px;
	height: 38.5px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: rgb(18, 63, 115);
}

.card-catalog {
	width: 18rem;
	border: none;
	box-shadow: none;
	background-color: #f3faff;
	max-height: 300px;
	margin: 0 10px;
	border-radius: 0.25rem;
	background-color: #fff;
	position: relative;
	display: flex;
	flex-direction: column;
	word-wrap: break-word;
}

.quick-view {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: #f4f6f8;
	padding: 5px 10px;
	border-radius: 4px;
	opacity: 0;
	transition: all 0.7s;
	font-size: 14px;
	color: #05386b;
}

.quick-view:hover {
	background: #e4e6f2;
	color: #4d4bae;
	cursor: pointer;
}

.card-catalog:hover .quick-view {
	opacity: 1;
	transition: all 0.7s;
}

.category-card-info {
	position: absolute;
	bottom: 0;
	right: 0;
	left: 0;
	background-color: rgba(66, 148, 209, 0.66);
	color: #ffff;
	padding: 1.25rem;
}

.category-cart-image {
	max-height: 300px;
	object-fit: contain;
}

.page-link {
	border: none;
	background-color: transparent;
	color: #1c6fd1 !important;
}

.active > .page-link {
	color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/LendingPage/Catalog/Catalog.css"],"names":[],"mappings":"AAAA;CACC,mCAAmC;CACnC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,SAAS;CACT,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,aAAa;CACb,gCAAgC;CAChC,WAAW;CACX,SAAS;AACV;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,mBAAmB;CACnB,eAAe;CACf,8BAA8B;CAC9B,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,2BAA2B;CAC3B,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,2CAA2C;CAC3C,kBAAkB;CAClB,eAAe;CACf,4BAA4B;CAC5B,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,WAAW;CACX,2CAA2C;CAC3C,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,WAAW;CACX,2CAA2C;AAC5C;;AAEA;CACC,+BAA+B;CAC/B,wBAAwB;CACxB,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,4DAA4D;CAC5D,WAAW;CACX,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,WAAW;CACX,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,2CAA2C;CAC3C,uCAAuC;AACxC;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,oCAAoC;CACpC,gBAAgB;CAChB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,uBAAuB;CACvB,wBAAwB;AACzB;;AAEA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,+CAA+C;AAChD;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,wBAAwB;CACxB,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;;CAEC,oBAAoB;CACpB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,WAAW;CACX,uBAAuB;CACvB,eAAe;CACf,2CAA2C;CAC3C,kBAAkB;AACnB;;AAEA;CACC;EACC,0BAA0B;CAC3B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,sBAAsB;EACtB,SAAS;EACT,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;CAC1B;;CAEA;EACC,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;CAChB;AACD;;AAEA;CACC,aAAa;CACb,aAAa;CACb,uBAAuB;CACvB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,oBAAoB;CACpB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,WAAW;CACX,mBAAmB;CACnB,YAAY;CACZ,OAAO;CACP,gCAAgC;AACjC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,yCAAyC;CACzC,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,4BAA4B;CAC5B,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,4BAA4B;CAC5B,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,UAAU;AACX;;AAEA;CACC,6BAA6B;CAC7B,cAAc;AACf;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,yCAAyC;CACzC,cAAc;CACd,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,yCAAyC;CACzC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,6BAA6B;CAC7B,gBAAgB;CAChB,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,uBAAuB;AACxB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,gBAAgB;CAChB,yBAAyB;CACzB,iBAAiB;CACjB,cAAc;CACd,sBAAsB;CACtB,sBAAsB;CACtB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;CACV,oBAAoB;CACpB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,OAAO;CACP,0CAA0C;CAC1C,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,6BAA6B;CAC7B,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;AACxB","sourcesContent":[".catalog-wrapper {\n\tbackground-color: var(--background);\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 40px;\n\twidth: 100%;\n\tpadding: 80px 0;\n}\n\n.catalog__content-wrapper {\n\tmax-width: 1340px;\n\tpadding: 0 20px;\n\tdisplay: grid;\n\tgrid-template-columns: 300px 1fr;\n\twidth: 100%;\n\tgap: 24px;\n}\n\n.catalog__header {\n\tdisplay: flex;\n\tmax-width: 1340px;\n\talign-items: center;\n\tpadding: 0 20px;\n\tjustify-content: space-between;\n\twidth: 100%;\n}\n\n.catalog__title {\n\tfont-size: 48px;\n\tline-height: 48px;\n\tcolor: var(--dark);\n}\n\n.catalog__search-wrapper {\n\tposition: relative;\n\tmin-width: 300px;\n}\n\n.catalog__search-icon {\n\tposition: absolute;\n\tright: 16px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tcursor: pointer;\n}\n\n.catalog__search-input {\n\twidth: 100%;\n\tpadding: 0 16px;\n\tborder: 1px solid var(--border-transparent);\n\tborder-radius: 4px;\n\tfont-size: 16px;\n\tcolor: var(--secondary-text);\n\theight: 44px;\n\tpadding-right: 40px;\n}\n\n.catalog__filters {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n\twidth: 100%;\n\tborder: 1px solid var(--border-transparent);\n\tborder-radius: 8px;\n\tpadding: 20px;\n\theight: fit-content;\n\tposition: sticky;\n\ttop: 20px;\n}\n\n.catalog__filter-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.catalog__filter-line {\n\theight: 1px;\n\twidth: 100%;\n\tbackground-color: var(--border-transparent);\n}\n\n.catalog__clear-filters-button {\n\tbackground-color: var(--button);\n\tcolor: var(--background);\n\tpadding: 8px 16px;\n\tborder-radius: 4px;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcursor: pointer;\n\ttransition: 0.3s;\n}\n\n.catalog__clear-filters-button:hover {\n\tbackground-color: var(--button-hover);\n\ttransition: 0.3s;\n}\n\n.catalog__filter-block-title {\n\tfont-size: 20px;\n\tline-height: 23px;\n\tcolor: var(--dark);\n}\n\n.catalog__filter-list-items {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 12px;\n}\n\n.catalog__products-list {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n\twidth: 100%;\n\tgap: 24px;\n}\n\n.catalog__products-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\twidth: 100%;\n\tgap: 24px;\n\tborder-radius: 16px;\n}\n\n.catalog__product-block {\n\tbackground-color: var(--background);\n\tborder-radius: 8px;\n\toverflow: hidden;\n\ttransition: 0.3s;\n\tcursor: pointer;\n\tposition: relative;\n\tborder: 1px solid var(--border-transparent);\n\tbox-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n}\n\n.catalog__hover-wrapper {\n\topacity: 0;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: rgba(0, 0, 0, 0.3);\n\ttransition: 0.3s;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.catalog__checkbox-wrapper {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n}\n\n.catalog__checkbox-wrapper input {\n\twidth: 20px;\n\theight: 20px;\n\tcolor: white;\n\tbackground-color: white;\n\tmargin-top: 0 !important;\n}\n\n.catalog__product-block:hover .catalog__hover-wrapper {\n\topacity: 1;\n\ttransition: 0.3s;\n}\n\n.catalog__product-details {\n\tpadding: 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 8px;\n\tborder-top: 1px solid var(--border-transparent);\n}\n\n.catalog__product-image {\n\twidth: 100%;\n\taspect-ratio: 1 / 1;\n\tborder-radius: 8px;\n}\n\n.catalog__product-title {\n\tfont-size: 16px;\n\tline-height: 20px;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tfont-weight: 500;\n}\n\n.catalog__view-button {\n\tbackground-color: var(--button);\n\tcolor: var(--background);\n\tpadding: 8px 16px;\n\tborder-radius: 4px;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcursor: pointer;\n\ttransition: 0.3s;\n}\n\n.catalog__view-button:hover {\n\tbackground-color: var(--button-hover);\n\ttransition: 0.3s;\n}\n\n.catalog__filter-item {\n\tfont-size: 15px;\n\tline-height: 16px;\n\tcolor: var(--dark);\n\tcursor: pointer;\n\tfont-weight: 500;\n\ttransition: 0.3s;\n}\n\n.catalog__filter-item:hover,\n.catalog__filter-item.selected {\n\tcolor: var(--button);\n\ttransition: 0.3s;\n}\n\n.catalog__empty-products {\n\tfont-size: 24px;\n\tline-height: 28px;\n\tcolor: var(--dark);\n\ttext-align: center;\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n\tpadding: 40px 0;\n\tborder: 1px solid var(--border-transparent);\n\tborder-radius: 8px;\n}\n\n@media (max-width: 950px) {\n\t.catalog__content-wrapper {\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t.catalog__filters {\n\t\tdisplay: none;\n\t}\n\n\t.catalog__header {\n\t\tflex-direction: column;\n\t\tgap: 20px;\n\t\talign-items: start;\n\t}\n\n\t.catalog__search-wrapper {\n\t\tposition: relative;\n\t\tmin-width: unset;\n\t\twidth: 100%;\n\t}\n\n\t.catalog__title {\n\t\tfont-size: 32px;\n\t\tline-height: 32px;\n\t\tcolor: var(--dark);\n\t\ttext-transform: uppercase;\n\t}\n\n\t.catalog-wrapper {\n\t\tbackground-color: var(--background);\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 30px;\n\t\twidth: 100%;\n\t\tpadding: 40px 0;\n\t}\n}\n\n.public-menu-a {\n\tpadding: 10px;\n\tdisplay: flex;\n\tcolor: rgb(18, 63, 115);\n\ttext-decoration: none;\n\tposition: relative;\n}\n\n.active-public {\n\tborder-color: rgb(18, 63, 115);\n}\n\n.active {\n\ttext-decoration: none;\n\tcolor: #1a4074;\n\ttransition: all 0.5s;\n\tposition: relative;\n}\n\n.catalog-active::after {\n\tposition: absolute;\n\tcontent: \"\";\n\theight: 2px;\n\twidth: 100%;\n\tborder-radius: none;\n\tbottom: -2px;\n\tleft: 0;\n\tborder-bottom: 2px solid #1c6fd1;\n}\n\n.dashboard-menu-ul {\n\tdisplay: flex;\n}\n\n.dashboard-menu-li {\n\tdisplay: flex;\n\tcursor: pointer;\n\tposition: relative;\n}\n\n.catalog-button-blue {\n\tborder: 1px solid rgba(28, 111, 209, 0.5);\n\tpadding: 7px 15px;\n\tborder-radius: 0;\n\tmargin-right: 7px;\n\tbackground: rgb(18, 63, 115);\n\tcolor: #fff;\n\ttransition: 0.4s;\n\tfont-weight: 300;\n\tfont-size: 15px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.catalog-button-blue:hover {\n\tbackground: rgb(18, 63, 115);\n\tcolor: #fff;\n}\n\n.max-height-38 {\n\tmax-height: 38.5px;\n\theight: 100%;\n}\n\n.catalog-search-input {\n\tbackground-color: #f3faff;\n\twidth: 90%;\n}\n\n.catalog-search-button {\n\tbackground-color: transparent;\n\tcolor: #c9c7d7;\n}\n\n.catalog-search-button:hover {\n\tcolor: rgb(18, 63, 115);\n}\n\n.search-box {\n\tborder: 1px solid rgba(28, 111, 209, 0.5);\n\tcolor: #c9c7d7;\n\theight: 38.5px;\n}\n\n.search-box svg {\n\tcursor: pointer;\n}\n\n.categories-wrapper-container {\n\tborder: 1px solid rgba(28, 111, 209, 0.5);\n\tpadding: 5px;\n}\n\n.categories-button-show {\n\tborder: none;\n\tbackground-color: transparent;\n\tmin-width: 150px;\n\theight: 38.5px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: rgb(18, 63, 115);\n}\n\n.card-catalog {\n\twidth: 18rem;\n\tborder: none;\n\tbox-shadow: none;\n\tbackground-color: #f3faff;\n\tmax-height: 300px;\n\tmargin: 0 10px;\n\tborder-radius: 0.25rem;\n\tbackground-color: #fff;\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\tword-wrap: break-word;\n}\n\n.quick-view {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tbackground: #f4f6f8;\n\tpadding: 5px 10px;\n\tborder-radius: 4px;\n\topacity: 0;\n\ttransition: all 0.7s;\n\tfont-size: 14px;\n\tcolor: #05386b;\n}\n\n.quick-view:hover {\n\tbackground: #e4e6f2;\n\tcolor: #4d4bae;\n\tcursor: pointer;\n}\n\n.card-catalog:hover .quick-view {\n\topacity: 1;\n\ttransition: all 0.7s;\n}\n\n.category-card-info {\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\tleft: 0;\n\tbackground-color: rgba(66, 148, 209, 0.66);\n\tcolor: #ffff;\n\tpadding: 1.25rem;\n}\n\n.category-cart-image {\n\tmax-height: 300px;\n\tobject-fit: contain;\n}\n\n.page-link {\n\tborder: none;\n\tbackground-color: transparent;\n\tcolor: #1c6fd1 !important;\n}\n\n.active > .page-link {\n\tcolor: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
